export default class Tooltip {

    constructor() {
        this.instance = self;
    }

    static init() {
        const self = new Tooltip;

        self.attachIcons();
        self.attachTooltips();

        window.site.attachTooltips = function() {
            self.attachIcons();
            self.attachTooltips();
        };
    }

    attachIcons() {
        $('[data-tooltip]').each((key, item) => {
           let tooltipText = $(item).data('tooltip');
           $(item).parent().append('<div class="tooltip"><div class="tooltip__icon"></div></div>');
        });
    }

    attachTooltips() {
        let targets = $('.tooltip'),
            target  = false,
            tooltip = false,
            title   = false;
        var self = this;

        $('.tooltip').on('click', function(e){
            e.stopPropagation();
        });

        targets.on('mouseleave', function() {
            let targetTip = $(this);
            if (targetTip.closest('.mod-document-status').length) {
                self.removeTooltip(targetTip);
            }
        });

        targets.on('mouseenter', function() {
            let targetTip = $(this);
            if (targetTip.closest('.mod-document-status').length) {
                self.showTooltip(targetTip);
            }
        });

        targets.on( "click", function() {
            let targetTip = $(this);

            if (targetTip.closest('.mod-document-status').length) {
                return false;
            }

            self.showTooltip(targetTip);
        });

        $('html').on('click', function() {
            $('#tooltip').remove();
        });
    }

    showTooltip(targetTip) {
        let target  = targetTip.parent().find('[data-tooltip]');
        let tip     = target.attr('data-tooltip');
        var tooltip = $('<div id="tooltip"></div>');

        $('#tooltip').remove();

        if (!tip || tip === '') return false;

        if (targetTip.closest('.mod-document-status').length) {
            tooltip.addClass('mod-document-status');
        }

        tooltip.css('opacity', 0).html(tip).appendTo('body');

        var init_tooltip = function() {
            // Bail out and clean up if the tooltip has been removed from the DOM
            if (!document.body.contains(tooltip[0])) {
                $(window).off('resize.ivtTooltip');
                return;
            }

            // Read phase 1: measure before constraining the tooltip width
            var windowWidth = $(window).width(),
                tooltipNaturalWidth = tooltip.outerWidth();

            // Write phase 1: apply max-width
            if (windowWidth < tooltipNaturalWidth * 1.5) {
                tooltip.css('max-width', windowWidth / 2);
            }
            else {
                tooltip.css('max-width', 340);
            }

            // Read phase 2: batch all remaining geometry reads in a single reflow
            var tipOffset = targetTip.offset(),
                tipOuterWidth = targetTip.outerWidth(),
                tooltipWidth = tooltip.outerWidth(),
                tooltipHeight = tooltip.outerHeight(),
                targetOffsetTop = target.offset().top,
                targetOuterHeight = target.outerHeight();

            var pos_left = tipOffset.left + (tipOuterWidth / 2) - (tooltipWidth / 2),
                pos_top  = tipOffset.top - tooltipHeight - 20,
                addClasses = [],
                removeClasses = [];

            if (pos_left < 0) {
                pos_left = tipOffset.left + tipOuterWidth / 2 - 20;
                addClasses.push('left');
            }
            else {
                removeClasses.push('left');
            }

            if (pos_left + tooltipWidth > windowWidth) {
                pos_left = tipOffset.left - tooltipWidth + tipOuterWidth / 2 + 20;
                addClasses.push('right');
            }
            else {
                removeClasses.push('right');
            }

            if (pos_top < 0) {
                pos_top = (targetOffsetTop + targetOuterHeight) - 20;
                addClasses.push('top');
            }
            else {
                removeClasses.push('top');
            }

            // Write phase 2: batch all class and style writes
            if (addClasses.length) {
                tooltip.addClass(addClasses.join(' '));
            }
            if (removeClasses.length) {
                tooltip.removeClass(removeClasses.join(' '));
            }

            tooltip.css({ left: pos_left, top: pos_top }).animate({ top: '+=10', opacity: 1 }, 50);
        };

        init_tooltip();

        $(window).off('resize.ivtTooltip').on('resize.ivtTooltip', init_tooltip);
    }

    removeTooltip(targetTip) {
        $('#tooltip').animate({ top: '-=10', opacity: 0 }, 50, function() {
            $(this).remove();
        });
    }
}
